function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useEffect, useReducer } from 'react';
import { Redirect, Route, Switch, useHistory } from 'react-router-dom';
import { FunctionalLoader, IntentBehaviorProvider, useDidUpdate, useOverlayContext } from 'seagull';
import RestfulWrapper from "../../components/RestfulWrapper/RestfulWrapper";
import { routes } from "../../constants";
import { useStore, useStoreActions } from "../../contexts";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { getIntentBehavior } from "../../infra/access-control";
import { relationshipModel } from "../../models";
import { requestAccountantAccessModel } from "../../models/request-accountant-access";
import { BIRelationshipScopeProvider } from "../../providers/BIRelationshipScopeProvider";
import { selectors } from "../../store/state-selectors";
import { clientOnboardingNavigateStateReducer, COBStep, isAllowedToGoBack, PreviewState } from "./ClientOnboarding.utils";
import { ClientOnboardingInner as ClientOnboardingInnerV1 } from "./ClientOnboardingInner";
import { ClientOnboardingInnerV2 } from "./ClientOnboardingInnerV2/ClientOnboardingInnerV2";
import { CobBrandingProvider } from "./CobBrandingContext";
import { CobStorageProvider, useCobStorage } from "./CobStorageContext";
import { changeBusinessLoader } from "./WelcomeStep/welcomeStepUtils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ClientOnboarding(props) {
  const userRole = useStore(selectors.user.role);
  const userId = useStore(selectors.user.id);
  const relationshipScope = {
    id: props.relationship.id,
    isApproved: relationshipModel.isApproved(props.relationship)
  };
  const {
    CLIENT_ONBOARDING_NEW_FLOW
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(BIRelationshipScopeProvider, {
    relationshipScope: relationshipScope,
    children: /*#__PURE__*/_jsx(IntentBehaviorProvider, {
      value: _objectSpread({}, getIntentBehavior(userRole, {
        relationshipState: {
          relationship: props.relationship,
          isPreviewMode: !!props.previewState
        },
        userId
      })),
      children: CLIENT_ONBOARDING_NEW_FLOW ? /*#__PURE__*/_jsx(ClientOnboardingInnerV2, _objectSpread({}, props)) : /*#__PURE__*/_jsx(ClientOnboardingInnerV1, _objectSpread({}, props))
    })
  });
}
export function ClientOnboardingRouted(props) {
  const {
    relationship
  } = props;
  const history = useHistory();
  const ff = useStore(selectors.ff.featureFlags);
  const businessId = useStore(selectors.user.businessId);
  const ffRelationshipVendorId = useStore(state => state.ff.relationshipVendorId);
  const {
    ff: {
      setRelationshipVendorId
    }
  } = useStoreActions();
  const {
    getFromStorage
  } = useCobStorage(relationship);
  const role = useStore(selectors.user.role);
  const userId = useStore(selectors.user.id);
  const fetchingFF = !ff.data || !ffRelationshipVendorId;
  const relationshipStatus = relationshipModel.status(relationship);
  const relationshipVendorId = relationshipModel.vendorID(relationship);
  const isVendor = useStore(selectors.user.isVendor);
  const [clientOnboardingNavigateState, dispatch] = useReducer(clientOnboardingNavigateStateReducer, {
    urlToNavigate: null,
    relationshipStatus: relationshipModel.status(relationship),
    role,
    relationshipId: relationshipModel.id(relationship),
    hasStartedWithPendingStatus: relationshipModel.isPending(relationship),
    isPrimary: relationshipModel.isBuyer(relationship, userId),
    vendorName: relationshipModel.vendorName(relationship),
    isVendor
  });
  useEffect(() => {
    if (clientOnboardingNavigateState.urlToNavigate) {
      const navigate = isAllowedToGoBack(clientOnboardingNavigateState.urlToNavigate) ? history.push : history.replace;
      navigate(clientOnboardingNavigateState.urlToNavigate, clientOnboardingNavigateState.state);
    }
  }, [clientOnboardingNavigateState.urlToNavigate, clientOnboardingNavigateState.state]);
  useEffect(() => {
    dispatch({
      type: 'RelationshipStatusChanged',
      status: relationshipStatus
    });
  }, [relationshipStatus]);
  useEffect(() => {
    setRelationshipVendorId(relationshipVendorId);
    return () => {
      setRelationshipVendorId();
    };
  }, [relationshipVendorId]);
  if (fetchingFF) {
    return /*#__PURE__*/_jsx(FunctionalLoader, {
      name: 'fetchFF',
      show: true
    });
  }
  return /*#__PURE__*/_jsxs(Switch, {
    children: [/*#__PURE__*/_jsx(Route, {
      path: "".concat(routes.clientOnboarding(), "/:stepId"),
      render: _ref => {
        var _ff$data;
        let {
          history,
          match
        } = _ref;
        const isV2 = (_ff$data = ff.data) === null || _ff$data === void 0 ? void 0 : _ff$data.CLIENT_ONBOARDING_NEW_FLOW;
        const initialBranding = isV2 ? _objectSpread(_objectSpread({}, relationship.vendor.branding), {}, {
          progressBarComplete: relationship.vendor.branding.buttonPrimary
        }) : relationship.vendor.branding;
        return /*#__PURE__*/_jsx(CobBrandingProvider, {
          initialBranding: initialBranding,
          children: /*#__PURE__*/_jsx(ClientOnboarding, {
            previewState:
            // A vendor can enter here by copying the proposal-link and pasting it in a new tab while logged in.
            relationship && relationship.vendor.id === businessId && !relationship.isSample ? PreviewState.Preview : undefined,
            refresh: props.refresh,
            relationship: relationship,
            currentStep: match.params.stepId,
            setCurrentStep: to => history.push(to)
          })
        });
      }
    }), /*#__PURE__*/_jsx(Route, {
      path: routes.clientOnboarding(),
      children: _ref2 => {
        var _getFromStorage;
        let {
          match
        } = _ref2;
        return /*#__PURE__*/_jsx(Redirect, {
          to: "".concat(match.url, "/").concat((_getFromStorage = getFromStorage('last_step')) !== null && _getFromStorage !== void 0 ? _getFromStorage : COBStep.welcome)
        });
      }
    })]
  });
}
export function ClientOnboardingQueryWrapper(props) {
  const {
    relationshipId
  } = props.match.params;
  const businessId = useStore(selectors.user.businessId);
  const {
    api
  } = useStoreActions();
  const overlayContext = useOverlayContext();
  useDidUpdate(() => {
    overlayContext.stopLoader(changeBusinessLoader);
  }, [businessId]);
  async function fetchData() {
    const [relationship, membersResponse] = await Promise.all([api.relationship.get(relationshipId), api.member.getAll()]);
    const shouldSetAccountants = requestAccountantAccessModel.wasRequested(relationship.requestAccountantAccess);
    return {
      relationship,
      accountants: shouldSetAccountants ? membersResponse.accountants : []
    };
  }
  return /*#__PURE__*/_jsx(RestfulWrapper, {
    fetch: fetchData,
    renderChild: _ref3 => {
      let {
        data,
        refresh
      } = _ref3;
      return /*#__PURE__*/_jsx(ClientOnboardingRouted, {
        relationship: data.relationship,
        refresh: refresh
      });
    }
  });
}
export default function ClientOnboardingContextWrapper(props) {
  return /*#__PURE__*/_jsx(CobStorageProvider, {
    children: /*#__PURE__*/_jsx(ClientOnboardingQueryWrapper, _objectSpread({}, props))
  });
}